// Shared rules for opportunities, used by the admin panel, the public listings and emails.
// The scraper has a CommonJS copy of isExpired in packages/scraper/src/expiry.js; keep them in step.

const todayIso = () => new Date().toISOString().slice(0, 10);

/**
 * The deadline as YYYY-MM-DD, whatever form it was stored in: date string (scraper and
 * admin form), ISO timestamp (old scraper), or Firestore Timestamp (old admin form).
 */
export function deadlineIso(opportunity) {
  const deadline = opportunity?.deadline;
  if (!deadline) return null;
  if (typeof deadline === 'string') {
    if (/^\d{4}-\d{2}-\d{2}/.test(deadline)) return deadline.slice(0, 10);
    const parsed = new Date(deadline);
    return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString().slice(0, 10);
  }
  if (typeof deadline.toDate === 'function') return deadline.toDate().toISOString().slice(0, 10);
  if (deadline instanceof Date) return deadline.toISOString().slice(0, 10);
  return null;
}

/** Closed, or the deadline has passed. */
export function isExpired(opportunity, today = todayIso()) {
  if (opportunity?.applicationStatus === 'closed') return true;
  const deadline = deadlineIso(opportunity);
  return Boolean(deadline && deadline < today);
}

/** Human deadline: "14 Nov 2026", the page's own wording, "Rolling", or null. */
export function formatDeadline(opportunity, locale) {
  const iso = deadlineIso(opportunity);
  if (iso) {
    // Date-only values are calendar dates, not instants: format in UTC so they don't shift a day.
    return new Date(`${iso}T00:00:00Z`).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
  }
  if (opportunity?.deadlineText) return opportunity.deadlineText;
  if (opportunity?.applicationStatus === 'rolling') return 'Rolling';
  return null;
}

/** Days until the deadline (negative once passed), or null without an exact date. */
export function daysUntilDeadline(opportunity, today = todayIso()) {
  const iso = deadlineIso(opportunity);
  if (!iso) return null;
  return Math.round((Date.parse(`${iso}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86400000);
}
